import { Component, ElementRef, inject } from '@angular/core';
import { SharedService } from '@core/service/shared.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-shared-service',
  template: '',
  standalone: true
})
export class SharedServiceComponent {

  constructor() {
    const element = inject(ElementRef);
    const sharedService = inject(SharedService);

    element.nativeElement.sharedServices = sharedService;
  }
}
